import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";

import {Injectable} from "@angular/core";
import {AuthService} from "./auth.service";

import {NotificationsService} from "angular2-notifications";

@Injectable()
export class AuthenticatedGuard implements CanActivate {
	constructor(
		public router: Router,
		public authService: AuthService,
		public service: NotificationsService,
	) {
	
	}
	
	
	/**
	 * Проверить доступность страницы для пользователя
	 * TODO Переписать проще
	 * @param {} route
	 * @param {} state
	 * @returns {Promise<boolean>}
	 */
	public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const me = this;
		
		await me.authService.fetch();
		
		if ( ! me.authService.isAuth) {
			try {
				const isLogginedByToken = await me.authService.loginByToken();
				if ( ! isLogginedByToken) {
					return me.router.navigate(['/sign_in']);
				}
				
				await me.authService.fetch();
			} catch (err) {
				console.log('canActivate error', err);
				
				return me.router.navigate(['/sign_in']);
			}
		}
		
		if (me.authService.isAuth) {
			await me.authService.fetchAllowedResources();
		}
		
		// Тут из полного клиентского роута
		// делаем имя роута для серверного бриджа,
		// который передаем на сервер и узнаем у ACL - можно ли сюда пользователю.
		const onlyRoutePath = state.url.split('?')[0]
			.replace(/^\//, '');
		
		await me.authService.checkGrantForRoute(onlyRoutePath);
		
		if ((state.url === '/' || state.url === '') && me.authService.isAnyGranted) {
			return true;
		}

		if ( ! me.authService.isAnyGranted || ! me.authService.isGranted) {
			me.service.error('Access Denied!');
			me.router.navigate(['/403']);
			
			return false;
		}
		
		return true;
	}
}
